module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-shadow-2.3ab0d57a.png";